import ForbiddenModal from "./ForbiddenModal";
export default ForbiddenModal;
